export default "__VITE_PUBLIC_ASSET__3b49d454__"